import React from "react";
import "./App.css";

// Public routes
import Track from "./components/driverApp/screen/Track";
import DriverApp from "./components/driverApp/screen/DriverApp";
import Confirmation from "./components/screen/Confirmation";
import Login from "./components/screen/Login.js";
import Register from "./components/screen/Register.js";
import ForgottenPassword from "./components/screen/ForgottenPassword";
import NotFound from "./components/screen/NotFound.js";
import CguHertzLaPremiereRedirect from "./components/screen/CguHertzLaPremiereRedirect.js";

// Admin & driver app routes
import Booking from "./components/screen/Booking.js";
import BookingSingle from "./components/screen/BookingSingle.js";
import BookingAdd from "./components/screen/BookingAdd.js";
import Customer from "./components/screen/Customer.js";
import CustomerAddOrUpdate from "./components/screen/CustomerAddOrUpdate.js";
import Company from "./components/screen/Company.js";
import CompanyAddOrUpdate from "./components/screen/CompanyAddOrUpdate.js";
import CompanyImport from "./components/screen/CompanyImport.js";
import Driver from "./components/screen/Driver.js";
import DriverAddOrUpdate from "./components/screen/DriverAddOrUpdate.js";
import Turnover from "./components/screen/Turnover.js";
import InvoiceStats from "./components/screen/InvoiceStats.js";
import Provider from "./components/screen/Provider.js";
import ProviderAddOrUpdate from "./components/screen/ProviderAddOrUpdate.js";
import ProviderService from "./components/screen/ProviderService.js";
import Users from "./components/screen/Users";
import UserAdd from "./components/screen/UserAdd";
import Vehicles from "./components/screen/Vehicles.js";
import VehicleAddOrUpdate from "./components/screen/VehicleAddOrUpdate.js";
import Events from "./components/screen/Events.js";
import EventsAddOrUpdate from "./components/screen/EventsAddOrUpdate.js";
import PriceAddOrUpdate from "./components/screen/PriceAddOrUpdate";
import Estimate from "./components/screen/Estimate";
import EstimateAdd from "./components/screen/EstimateAdd";
import SignEstimate from "./components/screen/SignEstimate";
import PaidEstimate from "./components/screen/PaidEstimate";
import Invoice from "./components/screen/Invoice";
import InvoiceAdd from "./components/screen/InvoiceAdd";
import Folder from "./components/screen/Folder";
import FolderAddOrUpdate from "./components/screen/FolderAddOrUpdate";

import Subscription from "./components/screen/Subscription";
import PaidSubscription from "./components/screen/PaidSubscription";
import Price from "./components/screen/Price";
import Profile from "./components/screen/Profile";
import Agents from "./components/screen/Agents.js";
import AgentAdd from "./components/screen/AgentAdd.js";
import Totp from "./components/screen/Totp";
import AgentInboxes from "./components/screen/AgentInboxes.js";

export const routes = [
  // region Display view routes
  {
    path: "/profile/",
    prevPath: "/profile/",
    component: <Profile />,
    display: false,
    subscriptionFree: true,
  },
  {
    path: "/folders/",
    prevPath: "/folders/",
    component: <Folder />,
    display: true,
    match: ["/folders", "/folders/"],
    icon: "icon-folder icon",
    label: "Dossiers",
    object: "folder",
    actions: ["read"]
  },
  {
    path: "/",
    prevPath: "/",
    component: <Booking />,
    display: true,
    match: [
      "/",
      "/booking",
      "/booking/",
      "/booking/:booking_id/",
      "/addBooking/",
    ],
    icon: "icon-booking icon",
    label: "Courses à venir",
    object: "booking",
    actions: ["read"]
  },

  {
    path: "/booking",
    prevPath: "/booking",
    component: <Booking />,
    display: false,
    match: [
      "/",
      "/booking",
      "/booking/",
      "/booking/:booking_id/",
      "/addBooking/",
    ],
    icon: "icon-booking icon",
    label: "Courses à venir",
    object: "booking",
    actions: ["read"]
  },
  {
    path: "/turnover/",
    prevPath: "/turnover/",
    component: <Turnover />,
    display: true,
    match: ["/turnover", "/turnover/"],
    icon: "icon-chiffres icon",
    label: "Chiffres",
    object: "turnover",
    objects: [
      { object: "turnover", path: "/turnover" },
      { object: "invoice", path: "/invoice-stats" }
    ],
    actions: ["read"]
  },
  {
    path: "/invoice-stats/",
    prevPath: "/invoice-stats/",
    component: <InvoiceStats />,
    display: false,
    match: ["/invoice-stats", "/invoice-stats/"],
    object: "invoice",
    actions: ["read"]
  },
  // region driver routes
  {
    path: "/company/",
    prevPath: "/company/",
    component: <Company />,
    display: true,
    label: "Chauffeurs",
    icon: "icon-businessman icon",
    match: [
      "/driver",
      "/addDriver",
      "/vehicle",
      "/addVehicle",
      "/company",
      "/addCompany",
    ],
    object: "company",
    objects: [
      { object: "company", path: "/company" },
      { object: "driver", path: "/driver" },
      { object: "vehicle", path: "/vehicle" },
    ],
    actions: ["read"]
  },
  {
    path: "/driver/",
    prevPath: "/driver/",
    component: <Driver />,
    display: false,
    label: "Chauffeurs",
    object: "driver",
    actions: ["read"]
  },
  {
    path: "/vehicle",
    prevPath: "/vehicle",
    component: <Vehicles />,
    display: false,
    label: "Véhicules",
    object: "vehicle",
    actions: ["read"]
  },
  // endregion
  // region customer routes
  {
    path: "/provider/",
    prevPath: "/provider/",
    component: <Provider />,
    display: true,
    match: ["/provider", "/addProvider", "/passenger", "/addCustomer"],
    icon: "icon-group icon",
    label: "Clients",
    object: "provider",
    objects: [
      { object: "provider", path: "/provider" },
      { object: "customer", path: "/passenger" },
    ],
    actions: ["read"]
  },
  {
    path: "/passenger/",
    prevPath: "/passenger/",
    component: <Customer />,
    display: false,
    object: "customer",
    actions: ["read"]
  },
  // endregion
  {
    path: "/price",
    prevPath: "/price",
    component: <Price />,
    display: true,
    match: ["/price", "/price/:price_id"],
    icon: "icon-dollar icon",
    label: "Tarifs",
    object: "pricing",
    actions: ["read"]
  },
  {
    path: "/events",
    prevPath: "/events",
    component: <Events />,
    display: true,
    match: ["/events", "/events/"],
    icon: "icon-event icon",
    label: "Evenements",
    object: "event",
    actions: ["read"]
  },
  {
    path: "/estimates",
    prevPath: "/estimates",
    component: <Estimate />,
    display: true,
    match: [
      "/estimates",
      "/estimates/",
      "/estimates/:estimate_id/",
      "/addEstimate/",
      "/invoices",
      "/invoices/",
      "/invoices/:invoice_id/",
      "/addInvoice/",
    ],
    icon: "icon-facture icon",
    label: "Devis / Factures",
    object: "estimate",
    objects: [
      { object: "estimate", path: "/estimates" },
      { object: "invoice", path: "/invoices" },
    ],
    actions: ["read"]
  },
  {
    path: "/invoices",
    prevPath: "/invoices",
    component: <Invoice />,
    display: false,
    icon: "icon-list icon",
    label: "Factures",
    object: "invoice",
    actions: ["read"]
  },
  {
    path: "/users",
    prevPath: "/users",
    component: <Users />,
    display: true,
    adminOnly: true,
    match: ["/users", "/users/"],
    icon: "icon-user-cog icon",
    label: "Utilisateurs",
  },
  {
    path: "/agents/",
    prevPath: "/agents/",
    component: <AgentInboxes />,
    display: true,
    label: "Agents",
    icon: "fa fa-phone icon",
    match: ["/agents", "/settings"],
    object: "agents",
    objects: [
        { object: "agents", path: "/agents" },
        { object: "settings", path: "/settings" }
    ],
    actions: ["read"]
},
{
    path: "/agents/",
    prevPath: "/agents/",
    component: <AgentInboxes />,
    display: false,
    label: "Chauffeurs",
    icon: "icon-agents icon",
    match: ["/agents"],
    object: "agents",
    objects: [{ object: "agents", path: "/agents" }],
    actions: ["read"]
},
{
    path: "/settings/",
    prevPath: "/settings/",
    component: <Agents />,
    display: false,
    label: "Chauffeurs",
    icon: "icon-settings icon",
    match: ["/settings"],
    object: "agents",
    objects: [{ object: "settings", path: "/settings" }],
    actions: ["read"]
},


  // endregion

  // region creation routes
  {
    path: "/addFolder/",
    prevPath: "/addFolder/",
    component: <FolderAddOrUpdate />,
    display: true,
    addLabel: "Créer un dossier",
    object: "folder",
    actions: ["create"]
  },
  {
    path: "/addBooking/",
    prevPath: "/addBooking/",
    component: <BookingAdd />,
    display: true,
    addLabel: "Ajouter une course",
    object: "booking",
    actions: ["create"]
  },
  {
    path: "/addCustomer/",
    prevPath: "/addCustomer/",
    display: true,
    component: <CustomerAddOrUpdate />,
    addLabel: "Ajouter un passager",
    object: "customer",
    actions: ["create"]
  },
  {
    path: "/addCompany/",
    prevPath: "/addCompany/",
    component: <CompanyAddOrUpdate />,
    display: true,
    addLabel: "Ajouter une entreprise",
    object: "company",
    actions: ["create"]
  },
  {
    path: "/addDriver/",
    prevPath: "/addDriver/",
    component: <DriverAddOrUpdate />,
    display: true,
    addLabel: "Ajouter un chauffeur",
    object: "driver",
    actions: ["create"]
  },
  {
    path: "/addProvider/",
    prevPath: "/addProvider/",
    component: <ProviderAddOrUpdate />,
    display: true,
    addLabel: "Ajouter un client",
    object: "provider",
    actions: ["create"]
  },
  {
    path: "/addVehicle",
    prevPath: "/addVehicle",
    component: <VehicleAddOrUpdate />,
    display: true,
    addLabel: "Ajouter un véhicule",
    object: "vehicle",
    actions: ["create"]
  },
  {
    path: "/addPrice",
    prevPath: "/addPrice",
    component: <PriceAddOrUpdate />,
    display: true,
    addLabel: "Ajouter un tarif",
    object: "pricing",
    actions: ["create"]
  },
  {
    path: "/addEvents",
    prevPath: "/addEvents",
    component: <EventsAddOrUpdate />,
    display: true,
    addLabel: "Ajouter un événement",
    object: "event",
    actions: ["create"]
  },
  {
    path: "/addEstimate",
    prevPath: "/addEstimate",
    component: <EstimateAdd />,
    display: true,
    addLabel: "Créer un devis",
    object: "estimate",
    actions: ["create"]
  },
  {
    path: "/addInvoice",
    prevPath: "/addInvoice",
    component: <InvoiceAdd />,
    display: true,
    addLabel: "Créer une facture",
    object: "invoice",
    actions: ["create"]
  },
  {
    path: "/add-user",
    prevPath: "/add-user",
    component: <UserAdd />,
    adminOnly: true,
    display: true,
    addLabel: "Créer un utilisateur",
  },

  {
    path: "/add-agent",
    prevPath: "/add-agent",
    component: <AgentAdd />,
    adminOnly: true,
    display: true,
    addLabel: "Créer un agent",
  },

  {
    path: "/edit-agent/:agentId",
    prevPath: "/edit-agent/:agentId",
    component: <AgentAdd />,
    adminOnly: true,
    display: false,
    addLabel: "Modifier un agent",
  },

  // endregion

  // region other routes
  {
    path: "/track/:uid/:token",
    isPublic: true,
    component: <Track />,
  },
  {
    path: "/chauffeur/:uid/link/:linkId",
    isPublic: true,
    component: <DriverApp />,
  },
  {
    path: "/chauffeur/:uid",
    isPublic: true,
    component: <DriverApp />,
  },
  {
    path: "/chauffeur",
    isPublic: true,
    component: <DriverApp />,
  },
  {
    path: "/sign-estimate/:uid/:token",
    isPublic: true,
    component: <SignEstimate />,
  },
  {
    path: "/paid-estimate/:uid/:stripeSessionId",
    isPublic: true,
    component: <PaidEstimate />,
  },
  {
    path: "/login",
    prevPath: "/login",
    isPublic: true,
    component: <Login />,
  },
  {
    path: "/register",
    prevPath: "/register",
    isPublic: true,
    component: <Register />,
  },
  {
    path: "/totp",
    prevPath: "/",
    component: <Totp />,
  },
  {
    path: "/forgotten-password",
    prevPath: "/forgotten-password",
    isPublic: true,
    component: <ForgottenPassword />,
  },
  {
    path: "/confirmation/:uid/:booking_id/:customer_id",
    prevPath: "/confirmation/:uid/:booking_id/:customer_id",
    isPublic: true,
    component: <Confirmation />,
  },
  {
    path: "/404",
    prevPath: "/404",
    isPublic: true,
    component: <NotFound />,
  },
  {
    path: "/cgu-hertz-la-premiere",
    isPublic: true,
    component: <CguHertzLaPremiereRedirect />,
  },
  {
    path: "/folders/:folder_id/",
    prevPath: "/folders/",
    component: <FolderAddOrUpdate />,
    object: "folder",
    actions: ["update"]
  },
  {
    path: "/booking/:booking_id/",
    prevPath: "/booking/",
    component: <BookingSingle />,
    object: "booking",
    actions: ["update"]
  },
  {
    path: "/passenger/:customer_id/",
    prevPath: "/passenger/",
    component: <CustomerAddOrUpdate />,
    object: "customer",
    actions: ["update"]
  },
  {
    path: "/company/:company_id/",
    prevPath: "/company/",
    component: <CompanyAddOrUpdate />,
    object: "company",
    actions: ["update"]
  },
  {
    path: "/importCompany/",
    prevPath: "/importCompany/",
    component: <CompanyImport />,
  },
  {
    path: "/driver/:driver_id/",
    prevPath: "/driver/",
    component: <DriverAddOrUpdate />,
    object: "driver",
    actions: ["update"]
  },
  {
    path: "/vehicle/:vehicle_id/",
    prevPath: "/vehicle/",
    component: <VehicleAddOrUpdate />,
    object: "vehicle",
    actions: ["update"]
  },
  {
    path: "/price/:price_id/",
    prevPath: "/price/",
    component: <PriceAddOrUpdate />,
    object: "pricing",
    actions: ["update"]
  },
  {
    path: "/provider/:provider_id/",
    prevPath: "/provider/",
    component: <ProviderAddOrUpdate />,
    object: "provider",
    actions: ["update"]
  },
  {
    path: "/provider/:provider_id/service",
    prevPath: "/provider/",
    component: <ProviderService />,
  },
  {
    path: "/events/:event_id",
    prevPath: "/events",
    component: <EventsAddOrUpdate />,
    object: "event",
    actions: ["update"]
  },
  {
    path: "/estimates/:estimateId",
    prevPath: "/estimates",
    component: <EstimateAdd />,
    object: "estimate",
    actions: ["update"]
  },
  {
    path: "/invoices/:invoiceId",
    prevPath: "/invoices",
    component: <InvoiceAdd />,
    object: "invoice",
    actions: ["update"]
  },
  {
    path: "/users/:userId",
    prevPath: "/users",
    component: <UserAdd />,
  },
  {
    path: "/subscription",
    prevPath: "/subscription",
    component: <Subscription />,
    subscriptionFree: true,
    adminOnly: true
  },
  {
    path: "/paid-subscription/:checkoutSessionId",
    prevPath: "/paid-subscription",
    component: <PaidSubscription />,
    subscriptionFree: true,
  },
  // endregion
];
